/**
 * The ONE import point pages use for enrollment/waitlist calls. Swapping the mock
 * for the real backend is a one-line change here (or REACT_APP_MOCK_ENROLLMENT_API=false).
 *
 * Default: mock in dev/test, HTTP in a production build. A production build must
 * never show a customer a mock "success" for something that was not sent.
 */
import { httpEnrollmentApi } from "./adapters/httpEnrollmentApi";
import { mockEnrollmentApi } from "./adapters/mockEnrollmentApi";

const flag = process.env.REACT_APP_MOCK_ENROLLMENT_API;
const useMock = flag === "true" || (flag === undefined && process.env.NODE_ENV !== "production");

export const enrollmentApi = useMock ? mockEnrollmentApi : httpEnrollmentApi;
